/* eslint-disable */
import * as React from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import Box from '@mui/material/Box';
import Permissions from '@/lib/permissions';
import EnaSettingsTable from './EnaSettingsTable';

function EnaSettingsPage() {
  return (
    <AppPage
      titlett="admin:page.ena_settings"
      needPermission={[Permissions.Administration]}
    >
      <Box m={0} style={{ height: '100%' }}>
        <EnaSettingsTable />
      </Box>
    </AppPage>
  );
}

export default EnaSettingsPage;
